import { render, staticRenderFns } from "./OngkirStats.vue?vue&type=template&id=0805b81a&scoped=true&"
import script from "./OngkirStats.vue?vue&type=script&lang=js&"
export * from "./OngkirStats.vue?vue&type=script&lang=js&"
import style0 from "./OngkirStats.vue?vue&type=style&index=0&id=0805b81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805b81a",
  null
  
)

export default component.exports